import React, { memo, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import SmartRender from "containers/SmartRender";
import Spinner, { styles } from "components/Spinner";
import { handleOnLoadAction, nextPageWithParams } from "utils/helpers";
import { fetchEsimQR } from "ducks/actions";
import {
  makeSelectOrderRef,
  makeSelectSessionToken,
  makeSelectEsimQRImage,
  makeSelectIsEsimQRFetching,
  makeSelectFormattedSelectedNumber,
  makeSelectAuthToken,
  makeSelectGuestOrderEsimProfile,
  makeSelectWorkflow
} from "ducks/selectors";
import { paths } from "utils/constants";

const ESimActivationHOC = Component =>
  function Comp(props) {
    const dispatch = useDispatch();
    const workflow = useSelector(makeSelectWorkflow());
    const ORDER_REF = useSelector(makeSelectOrderRef());
    const SESSION_TOKEN = useSelector(makeSelectSessionToken());
    const isFetchingQRCode = useSelector(makeSelectIsEsimQRFetching());
    const QR_IMG_BASE64_STRING = useSelector(makeSelectEsimQRImage());

    /**
     * Makes the API call to fetch Esim activation url
     */
    const getEsimQR = () => {
      const data = {
        order_ref: ORDER_REF,
        session_token: SESSION_TOKEN
      };
      dispatch(fetchEsimQR({}, data));
    };

    /**
     * Download the Server provided Esim QR code
     */
    const downloadQr = () => {
      const downloadAnchor = document.createElement("a");
      downloadAnchor.href = `${QR_IMG_BASE64_STRING}`;
      downloadAnchor.download = "esim_activation_qrcode.jpeg";
      downloadAnchor.click();
    };

    useEffect(() => {
      handleOnLoadAction({ ...props, workflow, getEsimQR });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Loading screen is shown until sim qr code is available
     */
    if (isFetchingQRCode) return <Spinner size={200} sx={styles.fullPage} />;

    return (
      <Component
        {...props}
        getEsimQR={getEsimQR}
        downloadQr={downloadQr}
        baseUrl={QR_IMG_BASE64_STRING}
      />
    );
  };

const mapStateToProps = createStructuredSelector({
  selectedNumber: makeSelectFormattedSelectedNumber(),
  authToken: makeSelectAuthToken(),
  esimProfile: makeSelectGuestOrderEsimProfile()
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  nextPage: nextPageWithParams(
    paths.DASHBOARD,
    stateProps.selectedNumber,
    stateProps.authToken
  )
});

export function mapDispatchToProps() {
  return {};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(withConnect, memo)(ESimActivationHOC(SmartRender));
